import { ICellProps } from '@creditflowresearch/uilib/Table/DataTable';
import Tooltip from '@creditflowresearch/uilib/Tooltip';
import Label from '@creditflowresearch/uilib/Badge/Label';
import { TOKENS } from '@creditflowresearch/uilib/constants/tokens';
import styles from './tickerCell.module.scss';

interface ITickerCell {
  cell: ICellProps,
  isCorporate?: boolean,
  isDeal?: boolean,
  isBadge?: boolean,
}

const TickerCell = ({
  cell: { row },
  isCorporate = false,
  isDeal = false,
  isBadge = false,
}: ITickerCell) => {
  const {
    primaryIssuer,
    issuers,
  } = isDeal ? row : row.deal;
  const name = primaryIssuer?.name;
  const issuerTicker = primaryIssuer?.issuerTicker || primaryIssuer?.ticker;
  const isMulti = issuers && issuers.length > 1;
  const tooltipContent = isMulti ? [primaryIssuer, ...issuers].map((issuer) => issuer.name).join(', ') : name;

  const getText = () => {
    if (isCorporate) return name || '-';
    if (isMulti) return 'MULTI';
    return issuerTicker || '-';
  };

  const text = getText();

  if (isBadge) {
    return (
      <Tooltip placement="bottom" content={ tooltipContent }>
        <Label className={ styles.badge } backgroundColor={ TOKENS.surface.neutralTag } textColor={ TOKENS.text.neutralPlaceholder }>
          { text }
        </Label>
      </Tooltip>
    );
  }

  return (
    <Tooltip placement="bottom" content={ tooltipContent }>
      <span>{ text }</span>
    </Tooltip>
  );
};

export default TickerCell;
